import createIcon from '../../createIcon';

/**
 * @component @name Router
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuMiA1LjlMMjEgNS4xQzE5LjYgMy43IDE3LjggMyAxNiAzQzE0LjIgMyAxMi40IDMuNyAxMSA1LjFMMTEuOCA1LjlDMTMgNC44IDE0LjUgNC4yIDE2IDQuMkMxNy41IDQuMiAxOSA0LjggMjAuMiA1LjlaTTE5LjMgNi43QzE4LjQgNS44IDE3LjIgNS4zIDE2IDUuM0MxNC44IDUuMyAxMy42IDUuOCAxMi43IDYuN0wxMy41IDcuNUMxNC4yIDYuOCAxNS4xIDYuNSAxNiA2LjVDMTYuOSA2LjUgMTcuOCA2LjggMTguNSA3LjVMMTkuMyA2LjdaTTE5IDEzSDE3VjlIMTVWMTNINUMzLjkgMTMgMyAxMy45IDMgMTVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVYxNUMyMSAxMy45IDIwLjEgMTMgMTkgMTNaTTggMThINlYxNkg4VjE4Wk0xMS41IDE4SDkuNVYxNkgxMS41VjE4Wk0xNSAxOEgxM1YxNkgxNVYxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Router = createIcon('Router', [
  [
    'path',
    {
      d: 'M20.2 5.9L21 5.1C19.6 3.7 17.8 3 16 3C14.2 3 12.4 3.7 11 5.1L11.8 5.9C13 4.8 14.5 4.2 16 4.2C17.5 4.2 19 4.8 20.2 5.9ZM19.3 6.7C18.4 5.8 17.2 5.3 16 5.3C14.8 5.3 13.6 5.8 12.7 6.7L13.5 7.5C14.2 6.8 15.1 6.5 16 6.5C16.9 6.5 17.8 6.8 18.5 7.5L19.3 6.7ZM19 13H17V9H15V13H5C3.9 13 3 13.9 3 15V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15C21 13.9 20.1 13 19 13ZM8 18H6V16H8V18ZM11.5 18H9.5V16H11.5V18ZM15 18H13V16H15V18Z',
      key: 'cw9l4b',
    },
  ],
]);

export default Router;
